import { convertToDatum } from '../../../Util';
import { TimeSeries, DateDatum } from '../';

const d3 = require('d3');


/**
 * 
 */
export class DateSeries extends TimeSeries {
  /**
   * Initialize a DateSeries from an input Array
   * 
   * @param {Array} input Array of Datum or Datum-compatible value pairs
   */
  constructor(input) {
    super();
    this.createObserver(); // Hack to avoid Vue destroying the class
    
    // Handle empty initialization
    let inputArray = input ?? [];
    this.push(...inputArray);
  }


  /**
   * Push Datum-compatible elements into the series
   * 
   * @param  {...any} inputArray List of items to add to the series
   */
  push(...inputArray) {
    for (let i of inputArray) {
      let datum = convertToDatum(i);

      if (datum instanceof DateDatum) {
        super.push(datum);
      } else {
        throw Error('Datum must be of Date type');
      }
    }
  }


  /**
   * Extend the DateSeries up to a given date (filled in according to the interval)
   * 
   * @param {Date} extensionEnd Date to extend series up to
   * @param {Number} extensionMonthInterval Months between each data point to add
   */
  extendSeries(extensionEnd, extensionMonthInterval = 3) {
    let finalDataDate = d3.max(this.getIndices());
    
    if (finalDataDate) {
      let extensionDates =
        d3.timeMonths(finalDataDate, extensionEnd, extensionMonthInterval)
          .slice(1) // Remove finalDataDate from array (included by d3 output)
          .map(date => [date, null]); // Include a null value

      this.push(...extensionDates);
    }
  }
}